import type { FaireProductEntity } from "../../entity_types/product";

export const p_d44cdykncq: FaireProductEntity = {
  token: "p_d44cdykncq",
  type: "product",
  name: "The Starter Collection",
  brandToken: "b_qgbeutab83",
  brandName: "Merigold",
  imageUrl:
    "https://cdn.faire.com/fastly/13073785e15338d17f7069e1eca4e8d91ece525c5ca52bce7bda71abae125722.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dce4416e8aed710248fc106c436cc270550040504a11feac6158c7b905c93cf3.png",
    "https://cdn.faire.com/fastly/6feccfec7e076a845509b1758a79a34ffb15d61ee030b506c23cf89494c61eab.png",
    "https://cdn.faire.com/fastly/efab94bac293564b6a63025e2a95e81d7810d6a7984ecbde4654558b564b8858.jpeg",
    "https://cdn.faire.com/fastly/7777ad460effe86be270e3d43313ef39883d789c3e066368eef70ac911c8ae4f.png",
    "https://cdn.faire.com/fastly/e8d5ce20336bc1dc0c8a346957dd523161ca961aa14ce6d2e0b83c7a451ebf79.png",
    "https://cdn.faire.com/fastly/7bf24e1758316c5eb71b6bc0598fde8c2f484b93ecca501dae966ab79f20e143.jpeg",
  ],
  priceDollars: 49.5,
  description:
    "Discover the Starter Collection from Merigold: a curated ensemble that intertwines intention with elegance.\n\nImmerse in a meaningful skincare ritual, utilizing a handcrafted ceramic bowl, wooden spoon, and the precision of a traditional hake brush, steeped in Japanese artistry. Personalize this moment of pause by selecting from our range of 12 exquisite powdered face masks to tailor the bundle to your skincare desires. Transition this mindfulness into your daily routine with our Revive and Restore Cleansing Oil, designed for everyday use, ensuring your skin is consistently embraced with care and intention.\n\nThis collection is not just a fleeting moment of pampering; it's a gift of sustained beauty and intentional self-care, from special rituals to daily routines.",
  tags: [],
  msrpDollars: 99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:07.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
